export default "__VITE_ASSET__2e8bdf0d__"